

/**
 * @ngdoc function
 * @name app.controller:ModalImportExcelActionCtrl
 * @description
 * # ModalImportExcelActionCtrl
 * Controller of the app
 */
angular.module('app')
	.controller('ModalImportExcelActionCtrl', /* @ngInject */ function ($scope, $uibModalInstance, API, bloc, el, structureBloc, templateOfBloc) {
		//console.log("modal info", bloc, el);
		//console.log('structureBloc', structureBloc);

		// Vars

		$scope.bloc = bloc;
		$scope.el = el;
		$scope.structureBloc = structureBloc;
		$scope.templateOfBloc = templateOfBloc;
		$scope.currentAction = '';
		$scope.currentActionParams = {};
		$scope.issetDb = false;
		$scope.krepre = false;

		//console.log("structureBloc = ", $scope.structureBloc);
		//console.log("templateOfBloc = ", $scope.templateOfBloc)

		//Debug function
		$scope.log = function (el, name) {
			//console.log(name, el);
		};

		if (bloc !== undefined) {
			//On est dans le bloc
		}
		else {
			//On est dans la template
		}

		//Action List
		$scope.actionList = [
			{
				id: 'condition',
				name: 'Condition',
			},
			{
				id: 'setValueByIndex',
				name: 'Valeur par index',
			},
			{
				id: '_SET_KID_',
				name: 'Définir kid',
			},
			{
				id: '_SET_VALUE_',
				name: 'Définir valeur',
			},
			{
				id: '_FIND_',
				name: 'Rechercher',
			},
			{
				id: '_FIND_BY_REPRE_',
				name: 'Rechercher par Krepre',
			},
			{
				id: '_EXIST_KID_',
				name: 'Kid existant',
			},
		];

		//Default Actions Presset
		//SET VALUE BY INDEX
		const setValueByIndex = {
			action: '_SET_VALUE_BY_INDEX_',
			index: 'defaut',
			name: 'defaut',
			actif: 1,
		};

		function addSetValueByIndex(ref) {
			ref.push({
				'name': 'setValueByIndex',
				'params': setValueByIndex,
			});
		}

		//Display

		$scope.hasChilds = function (el) {
			if (el.bloc_list !== undefined) {
				if (el.bloc_list.length > 0) {
					return true;
				}
				else {
					return false;
				}
			}
		};

		$scope.isKrepre = function (bloc) {
			if (bloc.id.split('::')[1] !== undefined && bloc.id.split('::')[1].includes('krepre')) {
				return true;
			}
			else {
				return false;
			}
		};

		if ($scope.hasChilds(el)) {
			el.opt.templateMode = false;
		}

		//Logic

		if ($scope.isKrepre($scope.bloc) && $scope.bloc.opt.templateMode === false) {
			if ($scope.bloc.actions.find(x => x.name === 'setValueByIndex') === undefined) {
				addSetValueByIndex($scope.bloc.actions);
			}
		}

		$scope.switchTemplateMode = function (templateMode) {
			if (templateOfBloc !== undefined) {
				templateOfBloc.displayTemplate = templateMode;
				//console.log("templateOfBloc.displayTemplate", templateOfBloc.displayTemplate)
			}

			if (templateMode === true) {
				//Bloc list kid = #template
			}
			else {
				//Bloc list with action list and no template
				if ($scope.bloc.actions.find(x => x.name === 'setValueByIndex') === undefined) {
					addSetValueByIndex($scope.bloc.actions);
				}
			}
		};

		//Actions

		//Define the ng-model of the current "Action" template
		$scope.getterSetterModel = function (pos, param) {
			if (pos === undefined) {
				return $scope.currentActionParams;
			}
			else {
				return pos['params'];
			}
		};

		//Delete all currentParams (temporary params)
		$scope.clearParams = function () {
			//console.log($scope.currentAction)
			$scope.currentActionParams = {};
		};

		//Add new action in actions
		$scope.addAction = function (actionName, actionParams) {
			$scope.bloc.actions.push(
				{
					'name': actionName,
					'params': actionParams,
				},
			);
		};

		//Clear temporary action (creation)
		$scope.cancelAction = function () {
			//console.log("salute")
			$scope.currentAction = $scope.actionList[0];
			$scope.currentActionParams = {};
		};

		//Delete action in actions
		$scope.removeAction = function (idx) {
			$scope.bloc.actions.splice(idx, 1);
		};

		//Modal

		$scope.submit = function () {
			$uibModalInstance.close();
		};

		$scope.cancel = function () {
			$uibModalInstance.dismiss();
		};
	});
